import React, { useState, useEffect } from "react";
import { Box, Card, Grid, Typography, Button, Paper, Tooltip, TableContainer, Modal, Table, Divider, TableBody, TableHead, Checkbox, TableCell, TableRow, IconButton, FormControl, TextField, CardContent, useTheme, alpha } from "@mui/material";
import ReportsHeader from "../../../components/ReportHeader";
import dayjs from "dayjs";
import Close from '@mui/icons-material/Close';

import 'dayjs/plugin/customParseFormat';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import GlobalConfig from "../../../config/date/GlobalConfig";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import TableFilterRow from "../../../components/table/TableFilterRow";
import CustomPagination from "../../../components/table/CustomPagination";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import { exportToExcel } from "../../../components/ExportToExcel";
import CustomDatePicker from "../../../components/CustomDatePicker";
const ReamBundleReport = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page
    const [currentPage, setCurrentPage] = useState(1);
    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [loadingData, setLoadingData] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [open, setOpen] = useState(false);
    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
        // getFGStockReport();
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
        //getFGStockReport();
    };

    const [loading, setLoading] = useState(false);
    const getReportData = () => {
        const formattedFromMODate = dayjs(FromDate).format('DD-MMM-YYYY');
        const formattedFromMODate1 = dayjs(ToDate).format('DD-MMM-YYYY');


        let parameters = {
            p_companyid: localStorage.getItem('companyid'),
            p_frommodate: formattedFromMODate,
            p_tomodate: formattedFromMODate1
        };
        setLoading(true);

        callApi(API_ENDPOINTS.REPORT_GetreportProductionReamBundleDetails, 'POST', { 'Content-Type': 'application/json' }, parameters)
            .then(data => {
                // Update state with fetched data
                setLoadingData(data);
                setLoading(false);

            })
            .catch(error => {
                setLoading(false);
                alert(error);

            });

    };

    useEffect(() => {
        // Fetch data when FromDate or ToDate changes
        getReportData();
    }, [FromDate, ToDate]);


    const [filters, setFilters] = useState({
        pr_number: '',
        child_reel_number: '',
        item_code: '',
        gsm: '',
        width: '',
        length: '',
    });
    const filteredData = loadingData.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const excelColumns = [
        { header: "BUNDLE PACKING DATE", key: "date" },            // 0 ✅ Date
        { header: "SHIFT.", key: "shift_code" },                   // 1
        { header: "PO NO.", key: "po_no" },                        // 2
        { header: "ROLL NO", key: "pr_number" },                   // 3
        { header: "REEL NO", key: "cr_number" },                   // 4
        { header: "QUALITY", key: "item_code" },                   // 5
        { header: "GRADE", key: "grade" },                         // 6
        { header: "GSM", key: "gsm" },                             // 7 ✅ Number
        { header: "SIZE 1", key: "width" },                        // 8 ✅ Number
        { header: "SIZE 2", key: "length" },                       // 9 ✅ Number
        { header: "NO OF SHEET", key: "no_of_sheets" },            // 10 ✅ Number
        { header: "REAM WT.", key: "ream_weight" },                // 11 ✅ Number
        { header: "PKT REAM", key: "reams_in_bundle" },            // 12 ✅ Number
        { header: "NO OF REAMS", key: "total_reams" },             // 13 ✅ Number
        { header: "NO OF BUNDLE FULL", key: "nooffullbundle" },    // 14 ✅ Number
        { header: "NO OF BUNDLE LOOSE", key: "noofloosebundle" },  // 15 ✅ Number
        { header: "TOTAL WEIGHT", key: "bundle_weight" },          // 16 ✅ Number
        { header: "ITEM", key: "size" },                           // 17
        { header: "REMARKS", key: "remarks" },                     // 18
        { header: "LOCATION", key: "b_location" },                 // 19
    ];

    const dateColumnIndexes = [0]; // "BUNDLE PACKING DATE"

    const handleExportToExcel = () => {
          exportToExcel({
            data: filteredData,
            fileName: 'Bundle and Pallet Production Detail Report.xlsx',
            sheetName: 'Bundle and Pallet Details',
            columns: excelColumns,           // 🔁 Fixed name
            dateColumnIndexes,
        });
        
        // const formattedData = filteredData.map(row => ({
        //     "BUNDLE PACKING DATE": row.date ? new Date(row.date) : "", // ensures proper Excel format
        //     "SHIFT.": row.shift_code,
        //     "PO NO.": row.po_no,
        //     "ROLL NO": row.pr_number,
        //     "REEL NO": row.cr_number,
        //     "QUALITY": row.item_code,
        //     "GRADE": row.grade,
        //     "GSM": row.gsm,
        //     "SIZE 1": row.width,
        //     "SIZE 2": row.length,
        //     "NO OF SHEET": row.no_of_sheets,
        //     "REAM WT.": row.ream_weight,
        //     "PKT REAM": row.reams_in_bundle,
        //     "NO OF REAMS": row.total_reams,
        //     "NO OF BUNDLE FULL": row.nooffullbundle,
        //     "NO OF BUNDLE LOOSE": row.noofloosebundle,
        //     "TOTAL WEIGHT": row.bundle_weight,
        //     "ITEM": row.size,
        //     "REMARKS": row.remarks,
        //     "LOCATION": row.b_location,
        // }));

      
    };

    const HandleClose = () => {
        handleExportToExcel();
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const pageCount = Math.ceil(filteredData.length / recordsPerPage);




    const uniqueValues = {

        shift_code: [...new Set(loadingData.map(row => row.shift_code))],
        po_no: [...new Set(loadingData.map(row => row.po_no))],
        item_code: [...new Set(loadingData.map(row => row.item_code))],
        grade: [...new Set(loadingData.map(row => row.grade))],
        gsm: [...new Set(loadingData.map(row => row.gsm))],
        b_location: [...new Set(loadingData.map(row => row.b_location))],
    };


    // Get the records for the current page
    const currentRecords = filteredData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );


    const columns = ['date', 'shift_code', 'po_no', 'pr_number', 'cr_number', 'item_code', 'grade', 'gsm', 'width', 'length', 'no_of_sheets', 'ream_weight', 'reams_in_bundle', 'total_reams', 'nooffullbundle', 'noofloosebundle', 'bundle_weight', 'size', 'remarks', 'b_location'];

    const autoCompleteColumns = ['shift_code', 'po_no', 'item_code', 'grade', 'gsm', 'b_location'];

    const totals = {
        no_of_sheets: filteredData.reduce((sum, r) => sum + (parseFloat(r.no_of_sheets) || 0), 0),
        ream_weight: filteredData.reduce((sum, r) => sum + (parseFloat(r.ream_weight) || 0), 0),
        total_reams: filteredData.reduce((sum, r) => sum + (parseFloat(r.total_reams) || 0), 0),
        nooffullbundle: filteredData.reduce((sum, r) => sum + (parseFloat(r.nooffullbundle) || 0), 0),
        noofloosebundle: filteredData.reduce((sum, r) => sum + (parseFloat(r.noofloosebundle) || 0), 0),
        bundle_weight: filteredData.reduce((sum, r) => sum + (parseFloat(r.bundle_weight) || 0), 0),

    };

    return (
        <>

            <Grid container alignItems="center" sx={{ mt: 0, mb: 0, pt: 0, pb: 0, justifyContent: "flex-start" }} >


                <Box ml={1}>
                    <Typography variant="h4" color={colors.grey[100]} fontWeight="semi bold" >Bundle and Pallet Production Detail Report</Typography>
                </Box>


                <Grid item mt="2px" ml="5px" mr="auto" justifyContent="center">
                    <IconButton onClick={() => { handleBackWinderMachineEntry() }}>
                        <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                    </IconButton>
                </Grid>

            </Grid>

            <Divider />

            <Grid container alignItems="center" sx={{ mt: 0, mb: 0, pt: 0, pb: 0, justifyContent: "flex-start" }} >



                <Grid ml={1} item xs={2} sm={3} md={1.5} lg={1} xl={1.5} mt="5px">

                     <CustomDatePicker
                                value={FromDate}
                                onChange={(date) => handleDateChange2(date)}
                                autoFocus={true}
                            />
                </Grid>


                <Grid item mt="2px" ml="10px" mr="10px">
                    <Typography fontWeight="bold">-</Typography>
                </Grid>

                <Grid item xs={2} sm={3} md={1.5} lg={1} xl={1.5} mt="5px" mr="10px">

                 
                    <CustomDatePicker
                                value={ToDate}
                                onChange={(date) => handleDateChange1(date)}
                            />
                </Grid>
                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                <Grid item mt="2px" ml="0px" mr="auto">

                    <Tooltip title="Download Report" onClick={HandleClose}>
                        <IconButton >
                            <FileDownloadIcon />
                        </IconButton>
                    </Tooltip>
                </Grid>



            </Grid>
            <Divider />

            <ResponsiveBox customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '74vh', xl: '82vh' }}>

                <CustomTableContainer colors={colors}>
                    <TableContainer >
                        {loading ? (
                            <SkeletonTableLoader rows={5} columns={11} />
                        ) : (


                            <Table size="small" >
                                <TableHead sx={{ height: 10 }}>
                                    <TableRow>
                                        <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }} >BUNDLE PACKING DATE</TableCell>
                                        <TableCell >SHIFT</TableCell>
                                        <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>PO NO.</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 300, whiteSpace: "nowrap" }}>JUMBO NO</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 300, whiteSpace: "nowrap" }}>REEL NO</TableCell>
                                        <TableCell >QUALITY</TableCell>
                                        <TableCell >GRADE</TableCell>
                                        <TableCell >GSM</TableCell>
                                        <TableCell >SIZE1</TableCell>
                                        <TableCell >SIZE2</TableCell>
                                        <TableCell >NO OF SHEET</TableCell>
                                        <TableCell >REAM WT.</TableCell>
                                        <TableCell >PKT.REAM</TableCell>
                                        <TableCell >NO.OF.REAMS</TableCell>
                                        <TableCell >NO.OF.BUNDLE.FULL</TableCell>
                                        <TableCell >NO.OF.BUNDLE.LOOSE</TableCell>
                                        <TableCell >TOTAL WEIGHT</TableCell>
                                        <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>ITEM</TableCell>
                                        <TableCell >REMARKS</TableCell>
                                        <TableCell >LOCATION</TableCell>
                                    </TableRow>

                                    <TableFilterRow
                                        columns={columns}
                                        filters={filters}
                                        handleFilterChange={handleFilterChange}
                                        uniqueValues={uniqueValues}
                                        autoCompleteColumns={autoCompleteColumns}
                                    />
                                </TableHead>
                                <TableBody>
                                    {currentRecords.map((row, index) => (
                                        <TableRow key={row.id} sx={{

                                            backgroundColor:
                                                index % 2 === 0
                                                    ? theme.palette.background.default
                                                    : alpha(theme.palette.action.hover, 0.04), // slightly darker
                                        }}>
                                            <TableCell>{row.date}</TableCell>
                                            <TableCell>{row.shift_code}</TableCell>
                                            <TableCell>{row.po_no}</TableCell>
                                            <TableCell>{row.pr_number}</TableCell>
                                            <TableCell>{row.cr_number}</TableCell>
                                            <TableCell>{row.item_code}</TableCell>
                                            <TableCell>{row.grade}</TableCell>
                                            <TableCell>{row.gsm}</TableCell>
                                            <TableCell>{row.width}</TableCell>
                                            <TableCell>{row.length}</TableCell>
                                            <TableCell>{row.no_of_sheets}</TableCell>
                                            <TableCell>{row.ream_weight}</TableCell>
                                            <TableCell>{row.reams_in_bundle}</TableCell>
                                            <TableCell>{row.total_reams}</TableCell>
                                            <TableCell>{row.nooffullbundle}</TableCell>
                                            <TableCell>{row.noofloosebundle}</TableCell>
                                            <TableCell>{row.bundle_weight}</TableCell>
                                            <TableCell>{row.size}</TableCell>
                                            <TableCell>{row.remarks}</TableCell>
                                            <TableCell>{row.b_location}</TableCell>
                                        </TableRow>
                                    ))}


                                    <TableRow sx={{ backgroundColor: colors.primary[400], height: 10 }}>
                                        <TableCell colSpan={10} sx={{ fontWeight: 'bold', textAlign: 'right' }}>TOTAL </TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.no_of_sheets.toFixed(2)}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.ream_weight.toFixed(2)}</TableCell>
                                        <TableCell /> {/* SIZE2 */}
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.total_reams.toFixed(2)}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.nooffullbundle.toFixed(2)}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.noofloosebundle.toFixed(2)}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.bundle_weight.toFixed(2)}</TableCell>
                                        <TableCell /> {/* REEL REF.NO */}
                                        <TableCell /> {/* REEL/SHEET */}
                                        <TableCell /> {/* REEL/SHEET */}
                                    </TableRow>
                                </TableBody>
                            </Table>)}
                    </TableContainer>
                </CustomTableContainer>

            </ResponsiveBox>
            <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />

        </>
    )
};
export default ReamBundleReport;